/**
 * microModal
 */

import Modal from 'micromodal';

const microModal = {
    cfg: {
       
    },

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            Modal.init();
        });
    }
};

export default microModal;



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/modal.js